export { default } from "./reducer";



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/reducer/index.js